import React from 'react';

const ErrorPage = () => {
    return (
        <div>
            <h1>This is Error 404</h1>
        </div>
    );
};

export default ErrorPage;